import Cookies from 'js-cookie';

export const getApiUrl = () => {
  const apiUrl = process.env.REACT_APP_API_URL?.trim() || process.env.NEXT_PUBLIC_API_URL?.trim();
  if (!apiUrl) {
    console.error('Error: API URL is not defined');
  }
  return apiUrl;
};

export const getAuthHeaders = () => {
  const token = Cookies.get('admin_auth_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};
